import { QueryFunctionContext } from "@tanstack/react-query";
import { axiosClientCMS } from "../api/apiClient";

export interface CaseStudiesInput {
  locale: string;
}

export type CaseStudyItem = {
  id: number;
  attributes: {
    content: string;
    createdAt: string;
    locale: string;
    publishedAt: string;
    title: string;
    perex: string;
    updatedAt: string;
    image?: any;
  };
};

export type CaseStudyResponse = {
  meta: any;
  data: CaseStudyItem[];
};

export const fetchCaseStudies = async ({
  queryKey,
}: QueryFunctionContext<
  [string, CaseStudiesInput]
>): Promise<CaseStudyResponse> => {
  const [, { ...params }] = queryKey;
  return axiosClientCMS
    .get("/case-studies", { params: { ...params, populate: "image" } })
    .then((data) => data.data);
};
